<div class="modal-header">
  <div class="d-flex flex-column w-100">
    <div class="d-flex flex-row justify-content-between">
      <p [innerText]="message"></p>
      <tr-icon [icon]="icon.cancel" (click)="close()"></tr-icon>
    </div>

    <button
      class="btn btn-light w-100"
      *ngIf="displayButton"
      [innerText]="buttonText"
      (click)="closedWithButtonClick()"
    ></button>
  </div>
</div>
